<template>
    <base-section
      id="scan"
      space="10"
      class="grey lighten-4"
    >
      <v-container>
        <v-row justify="space-between">
          <v-col
            cols="12"
            md="12"
          >
            <base-business-info title="Cek Data" text="">
            </base-business-info>
            <template>
                    <v-progress-linear indeterminate color="primary" v-if="loading"></v-progress-linear>
                    <!-- <v-text-field
                      v-model="form.number"
                      :loading="loading"
                      :readonly="true"
                      append-icon="mdi-lock"
                      density="compact"
                      label="Nomor Batch/Certificate/Claim"
                      hide-details
                      @click:append="Decrypt"
                    ></v-text-field>-->
              </template>
          </v-col>
        </v-row>
      </v-container>
       <!-- Dialog component -->
        <v-dialog v-model="dialog" max-width="500px" persistent>
            <v-card>
            <v-card-title class="primary white--text">Verified <v-icon color="green">mdi-check-decagram</v-icon> <v-spacer></v-spacer><v-btn color="white" text @click="Close">Tutup</v-btn></v-card-title>
            <!-- <v-card-subtitle>Here is a table with some data:</v-card-subtitle> -->
    
            <!-- Data Table -->
            <template v-for="row in posts">
            <v-simple-table :key="row.website_batchno" dense>
                <template v-slot:default>
                  <thead>
                    <template v-if="form.flag === 'BATCH'">
                    <tr>
                      <th class="text-right">
                        Batch No :
                      </th>
                      <th class="text-left">
                        {{ row.website_batchno }}
                      </th>
                    </tr>
                    </template>
                    <tr>
                        <th class="text-right">
                          Certificate No :
                        </th>
                        <th class="text-left">
                          {{ row.website_certificateno }}
                        </th>
                      </tr>
                      <tr>
                        <th class="text-right">
                          Issued Date :
                        </th>
                        <th class="text-left">
                          {{ $functions.FormatDateIndo(row.website_bookdate) }}
                        </th>
                      </tr>
                      <tr v-if="form.flag !== 'BATCH'">
                        <th colspan="2">
                          <object
                            id="pdfViewer"
                            type="application/pdf"
                            width="100%"
                            height="600px"
                            :data="pdfUrlWithParams"
                          ><p v-if="form.flag !== 'BATCH'">File tidak dapat ditampilkan. Silakan download <a :href="pdfUrlWithParams" target="_blank" rel="noopener noreferrer">di sini</a>.</p>
                        </object>
                        </th>
                      </tr>
                    <template v-if="form.flag === 'BATCH'">
                    <tr>
                        <th class="text-right">
                          Total Data :
                        </th>
                        <th class="text-right">
                          {{ $functions.FormatNumber(row.website_totaldata,0) }}
                        </th>
                    </tr>
                    <tr v-if="row.website_hiddenvolume === 'N'">
                        <th class="text-right">
                          Total Plafond Kredit :
                        </th>
                        <th class="text-right">
                          {{ $functions.FormatNumber(row.website_totalguaranteevolume,0) }}
                        </th>
                      </tr>
                    <tr>
                        <th class="text-right">
                          Total Nilai Penjaminan :
                        </th>
                        <th class="text-right">
                          {{ $functions.FormatNumber(row.website_totalguaranteevalue,0) }}
                        </th>
                      </tr>
                    <tr>
                        <th class="text-right">
                          Total IJP :
                        </th>
                        <th class="text-right">
                          {{ $functions.FormatNumber(row.website_totalguaranteefee,0) }}
                        </th>
                      </tr>
                    </template>
                  </thead>
                </template>
              </v-simple-table>
            </template>
    
            <!-- Actions -->
            <v-card-actions>
              <base-img
              :src="require('@/assets/logo-orion.png')"
              class="mt-0"
              contain
              width="200"
              style="height: 50px"
            />
                <v-spacer></v-spacer>
                PT. Orion Penjaminan Indonesia
            </v-card-actions>
            </v-card>
        </v-dialog>
      <v-snackbar 
            :timeout="snackbar.timeout"
            :color="snackbar.color"
            v-model="snackbar.dialog"
            top
            >
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  @click="snackbar.dialog = false"
                >
                  Close
                </v-btn>
              </template>
        </v-snackbar>
    </base-section>
  </template>
  
  <script>
    import { PDFDocument, rgb, degrees, StandardFonts } from 'pdf-lib'
    export default {
      name: 'SectionScan',
        data: () => ({
            posts: [],
            images: [],
            pdfUrl: '',
            loading: false,
            form: {
                number: '',
                flag: '',
                ecertificate: '',
            },
            dialog: false,
            snackbar: {
                dialog: false,
                color: 'success',
                text: '',
                timeout: 3000,
            },
        }),
        computed: {
          pdfUrlWithParams() {
            return this.pdfUrl ? this.pdfUrl + '#toolbar=0&navpanes=0&scrollbar=0' : '';
          }
        },
        created() {
            let access = Object.keys(this.$route.query)[0]
            if (access === undefined) {
                let data = this
                data.SnackBar(true,'error','Invalid URL',2000)
                setTimeout(() => {
                    data.$router.push({ name: "beranda"})
                }, 1500)
            } else {
              this.Decrypt()
            }
        },
        methods: {
          async ProcessBase64PDF(base64) {
            const pdfData = atob(base64); // decode base64 ke binary string
            const uint8Array = new Uint8Array([...pdfData].map(char => char.charCodeAt(0)));

            const pdfDoc = await PDFDocument.load(uint8Array);
            const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

            const watermarkText = 'REVIEW VALIDASI';
            const fontSize = 60;
            const spacing = 200; // Jarak antar watermark berulang

            pdfDoc.getPages().forEach((page) => {
              const { width, height } = page.getSize();

              // Hitung jumlah watermark yang dibutuhkan untuk mengisi halaman secara diagonal
              const diagonalLength = Math.sqrt(width ** 2 + height ** 2);

              for (let yOffset = -diagonalLength / 2; yOffset < diagonalLength; yOffset += spacing) {
                page.drawText(watermarkText, {
                  x: width / 2 - font.widthOfTextAtSize(watermarkText, fontSize) / 2,
                  y: yOffset,
                  size: fontSize,
                  font,
                  color: rgb(1, 0, 0),
                  rotate: degrees(-45),
                  opacity: 0.15,
                });
              }
            });

            const pdfBytes = await pdfDoc.save();
            const blob = new Blob([pdfBytes], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob)
            this.pdfUrl = url
            document.getElementById('pdfViewer').src = url;
          },
            Decrypt () {
                this.loading  = true
                let scan = Object.keys(this.$route.query)[0]
                let formdata = {
                    encrypt_data: scan
                }
                let param      = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiDecryptBarcode'),param,{
                headers: {
                    'Content-Type': 'text/plain; charset=ISO-8859-1'
                }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                        let split = feedback[0].decrypt_data.split("=")
                        let modul = split[0]
                        // let document = split[1]
                        let id = split[2]
                        if (id.includes('OPISP')) {
                          this.form.flag = 'BATCH'
                        } else {
                          this.form.flag = 'ROW'
                        }
                        this.CheckData(modul, id)
                        } else {
                            this.SnackBar(true,'error',feedback[0].feedback,5000)
                        }
                    }
                    this.loading  = false
                })
                .catch(e => {
                    this.SnackBar(true,'error',e,5000)
                    this.loading  = false
                })
            },
            CheckData(modul, id) {
                let formdata = {
                    website_modul: modul,
                    website_id: id,
                }
                let param      = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiWebsiteData'),param,{
                headers: {
                    'Content-Type': 'text/plain; charset=ISO-8859-1'
                }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            if (this.form.flag === 'BATCH') {
                              this.form.number = feedback[0].website_batchno
                            } else {
                              this.form.number = feedback[0].website_certificateno
                            }
                            this.posts = feedback
                            this.dialog = true
                            this.SnackBar(true,'success','Data yang dimasukkan Valid dan Verified',3000)
                            this.ProcessBase64PDF(feedback[0].website_ecertificate)
                        } else {
                            this.SnackBar(true,'error',feedback[0].feedback,5000)
                        }
                    } else {
                      this.SnackBar(true,'error','Mohon maaf data yang di scan tidak valid',5000)
                    }
                    this.loading  = false
                })
                .catch(e => {
                    this.SnackBar(true,'error',e,5000)
                    this.loading  = false
                })
            },
            SnackBar (dialog, color, text, timeout) {
                this.snackbar.dialog  = dialog
                this.snackbar.color   = color
                this.snackbar.text    = text
                this.snackbar.timeout = timeout
            },
            Close () {
              this.form.number = ''
              this.dialog = false
            },
        }
    }
  </script>